import { AppliedOrientation } from './capture-orientation';

export const EXHIBIT_SET_SCHEMA_VERSION = 1;

export enum CaptureMethod {
  DeviceCamera = 'device-camera',
  PreviewFrame = 'preview-frame',
  CameraApp = 'camera-app',
}

export const CAPTURE_METHOD_LABELS: Readonly<Record<CaptureMethod, string>> = {
  [CaptureMethod.DeviceCamera]: 'In-app camera, full resolution',
  [CaptureMethod.PreviewFrame]: 'In-app camera, preview frame',
  [CaptureMethod.CameraApp]: 'Device camera app',
};

export interface CapturedPhoto {
  readonly blob: Blob;
  readonly mimeType: string;
  readonly byteLength: number;
  readonly sha256: string;
  readonly sha512: string;
  readonly capturedAtIso: string;
  readonly deviceFileTimeIso: string;
  readonly captureMethod: CaptureMethod;
  readonly orientation?: AppliedOrientation;
}

export interface ExhibitPhoto extends CapturedPhoto {
  readonly sequence: number;
  readonly fileName: string;
}

export interface ExhibitSetDetails {
  readonly reference: string;
  readonly subject: string;
  readonly location: string;
  readonly description: string;
}

export interface ExhibitSet {
  readonly details: ExhibitSetDetails;
  readonly photos: readonly ExhibitPhoto[];
  readonly restartCount: number;
  readonly discardedPhotoCount: number;
  readonly retakeCount: number;
}

export interface ExhibitPhotoManifestEntry {
  readonly sequence: number;
  readonly fileName: string;
  readonly sha256: string;
  readonly sha512: string;
  readonly capturedAtIso: string;
  readonly deviceFileTimeIso: string;
  readonly captureMethod: string;
  readonly byteLength: number;
  readonly orientation?: AppliedOrientation;
}

export interface ExhibitSetManifest {
  readonly schemaVersion: number;
  readonly reference: string;
  readonly subject: string;
  readonly location: string;
  readonly photos: readonly ExhibitPhotoManifestEntry[];
}
